export default [
  {
    path: '/flags',
    meta: { auth: 'administrator' },
    component: () => import(/* webpackChunkName: 'flag-list' */ '@/views/flags/List.vue')
  }
]
